<template lang="pug">
info-card(
  :title='$t("modal.envelope.recipients")'
  icon='users'
  icon-color='blue'
)
  template(v-slot:action)
    button.icon-button(
      @click='$emit("resend-notification")'
      type='button'
      v-if='envelopeState === "in-transit" && !onlyFaceToFace'
      v-tooltip:top='resendTooltipMessage'
    )
      icon(name='share-from-square')
  .recipients-list
    .recipient-item(
      :key='recipient.id'
      v-for='(recipient, index) in recipients'
    )
      .recipient-main
        .recipient-name {{ recipient.addressees[0].name }}
        .recipient-row(
          :key='`img-${identifierIndex}`'
          v-for='(identifier, identifierIndex) in recipient.addressees[0].identifiers'
          v-if='identifier.type !== "image"'
        )
          span.text {{ identifier.title }}: {{ identifier.value }}
        .recipient-row(v-if='recipient.addressees[0].via !== "face-to-face"')
          span.text {{ recipient.addressees[0].value }}
        .recipient-row
          span.text {{ $t('modal.envelope.recipientType') }}: {{ recipientLabel(recipient.type) }}
        .recipient-row(v-if='isSignerType(recipient)')
          info-pill(
            :active='!isExcludedSignerFromDocument(recipient)'
            :icon='isExcludedSignerFromDocument(recipient) ? "eye" : "signature"'
          ) {{ formatDocRecipientLabel(recipient) }}
        .recipient-row
          status-badge(
            :status='recipient.state'
            v-if='!isExcludedSignerFromDocument(recipient) && !isApproverType(recipient)'
          )
          info-pill(:icon='"eye"' v-else) {{ $t('modal.envelope.toViewed') }}
      button.icon-button(
        @click='$emit("edit-recipient", index)'
        type='button'
        v-if='recipientIsPending(recipient.state) && userView === "sender" && !onlyFaceToFace'
      )
        icon(name='pen-to-square')
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import InfoCard from '@/modules/business/components/molecules/InfoCard.vue';
import StatusBadge from '@/modules/business/components/molecules/StatusBadge.vue';
import InfoPill from '@/modules/business/components/molecules/InfoPill.vue';
import RecipientType from '@/enums/RecipientType';
import RecipientState from '@/enums/RecipientState';

export default {
  name: 'RecipientsPanel',
  components: {
    Icon,
    InfoCard,
    StatusBadge,
    InfoPill,
  },
  props: {
    recipients: {
      type: Array,
      required: true,
    },
    userView: {
      type: String,
      required: true,
    },
    onlyFaceToFace: {
      type: Boolean,
      default: false,
    },
    selectedDocInfo: {
      type: Object,
      default: null,
    },
    resendTooltipMessage: {
      type: String,
      default: '',
    },
    envelopeState: {
      type: String,
      default: '',
    },
  },
  methods: {
    recipientLabel(recipientType) {
      const typeValue = RecipientType.values.filter(
        (type) => type.value === recipientType
      );
      return typeValue[0].value !== 'carbon-copy'
        ? this.$t(`modal.envelope.${typeValue[0].value}`)
        : this.$t('modal.envelope.viewer');
    },
    recipientIsPending(state) {
      return state === RecipientState.WAITING;
    },
    isExcludedSignerFromDocument(recipient) {
      if (!this.selectedDocInfo) {
        return false;
      }
      return !this.selectedDocInfo.signers.some((r) => r.id === recipient.id);
    },
    isSignerType(recipient) {
      return (
        recipient.type === RecipientType.SIGNER ||
        recipient.type === RecipientType.IN_PERSON_SIGNER
      );
    },
    isApproverType(recipient) {
      return recipient.type === RecipientType.APPROVER;
    },
    formatDocRecipientLabel(recipient) {
      const isSigner = !this.isExcludedSignerFromDocument(recipient);
      return isSigner
        ? this.$t('modal.envelope.isSignerInDocument')
        : this.$t('modal.envelope.isNotSignerInDocument');
    },
  },
};
</script>

<style scoped lang="stylus">
.icon-button
  display: flex
  align-items: center
  justify-content: center
  flex: 0 0 auto
  width: 1.75rem
  height: 1.75rem
  border: none
  background: transparent
  color: #007bff

.recipients-list
  display: flex
  flex-direction: column
  gap: 0.75rem

.recipient-item
  display: flex
  align-items: flex-start
  justify-content: space-between
  gap: 0.75rem
  padding: 0.9rem 1rem
  border: 1px solid rgba(204, 204, 204, .5)
  border-radius: 8px

.recipient-main
  display: flex
  flex-direction: column
  gap: 0.35rem
  min-width: 0

.recipient-name
  font-weight: 600
  font-size: 0.85rem

.recipient-row
  display: flex
  align-items: center
  gap: 0.4rem
  font-size: 0.8rem
  color: #495057
</style>
